import { IBaseModalComponent } from '@app/components/modals/base/i-base.modal-component';
import { UnsubscriberBase } from '@core/services/unsubscriber.base';
import { Observable, of } from 'rxjs';

export class BaseModalComponent extends UnsubscriberBase implements IBaseModalComponent {
	protected _title = 'Not Set';
	protected _hideFunc: () => void;

	public setOnHide(func: () => void): void {
		this._hideFunc = func;
	}

	public onBackdropClick(): Observable<void> {
		return of(null);
	}

	public get title(): string {
		return this._title;
	}
}
